import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import SoFormContainer from '../../components/layout/SoFormContainer';
import SoFormTitle from '../../components/other/SoFormTitle';
import SoFormCandidateBlock from './blocks/SoFormCandidateBlock';
import { useSoFormStepsState } from '../../SoForm.context';
import { useTranslation } from 'react-i18next';

const PriceDisclaimerContainer = styled.div`
  margin-right: auto;
  text-align: left;
`;

const PriceDisclaimerText = styled.div`
  /* 14px/regular */

  height: 24px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* or 114% */

  display: flex;
  /* flex-direction: column; */
  align-items: center;

  /* grey / 700 */

  color: #54708c;
`;

const PriceDisclaimer = () => {
  const { t } = useTranslation('Catalog');
  const stepsState = useSoFormStepsState();
  const hasZipCodes = false;
  const isRFQ = stepsState.price.candidates.some(
    (c) => c.pricing_strategy === 'RFQ' || c.pricing_strategy === 'RFQ_RANGE'
  );
  if (!hasZipCodes && !isRFQ) return <></>;
  else if (hasZipCodes)
    return (
      <PriceDisclaimerContainer>
        <PriceDisclaimerText>
          <b>{t('price.approximate_prices_by_zip_code')}</b>
        </PriceDisclaimerText>
        <PriceDisclaimerText>
          {t('price.price_could_change_by_zip_code')}
        </PriceDisclaimerText>
      </PriceDisclaimerContainer>
    );
  else if (isRFQ)
    return (
      <PriceDisclaimerContainer>
        <PriceDisclaimerText>{t('price.rfq_disclaimer')}</PriceDisclaimerText>
      </PriceDisclaimerContainer>
    );
};

const SoFormStepPriceBody = ({ className }) => {
  const { t } = useTranslation('Catalog');
  const stepsState = useSoFormStepsState();
  const candidates = stepsState.price.candidates;
  return (
    <div className={className}>
      <SoFormContainer>
        <SoFormTitle> {t('price.header')}</SoFormTitle>
        <PriceDisclaimer />
        {candidates.map((c) => (
          <SoFormCandidateBlock candidate={c} key={c.productType} />
        ))}
      </SoFormContainer>
    </div>
  );
};

SoFormStepPriceBody.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepPriceBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 0px;
  width: 100%;
  ${SoFormContainer} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0px;
    gap: 16px;
    padding: 0;
  }
  ${SoFormTitle} {
    margin: 0;
  }
  flex-grow: 1;
`;
